export const  types = {
    JWTENCODE: 'JWT-ENCODE',
    JWTDECODE: 'JWT-DECODE'
};